import { create } from 'zustand'

interface IChangeColorAsset {
    isDownloadedCompletePS: boolean
    setIsDownloadedCompletePS: (isDownloadedCompletePS: boolean) => void
    showDownloadAssetPS: boolean
    setShowDownloadAssetPS: (showDownloadAssetPS: boolean) => void
}

export const useChangeColorAsset = create<IChangeColorAsset>((set) => ({
    isDownloadedCompletePS: false,
    setIsDownloadedCompletePS: (isDownloadedCompletePS) => set({ isDownloadedCompletePS }),
    showDownloadAssetPS: false,
    setShowDownloadAssetPS: (showDownloadAssetPS) => set({ showDownloadAssetPS }),
}))
